import { Box, Collapse, IconButton, TableCell, TableRow } from '@mui/material';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TestDetailsList from '../../components/TestDetailsList';

export function DoctorRow({ doctor, fromDate, toDate }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow key={doctor.email} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {doctor.hospital}
        </TableCell>
        <TableCell>{doctor.email}</TableCell>
        <TableCell>{doctor.patients}</TableCell>
        <TableCell>{doctor.tests}</TableCell>
        <TableCell>{doctor.validFace}</TableCell>
        <TableCell>{doctor.validSpeech}</TableCell>
        <TableCell>{doctor.validArms}</TableCell>
        <TableCell>{doctor.validNeurologicalExamination}</TableCell>
        <TableCell>{doctor.forReview}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <TestDetailsList email={doctor.email} fromDate={fromDate} toDate={toDate} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
